import { Cliente, ClienteDaImportacaoCSV, FormCliente, Page } from '@/models'
import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'

const PATH = '/clientes'

export const create = async (data: FormCliente): Promise<Cliente> =>
	await request.post(`${PATH}`, data)

export const update = async (data: FormCliente): Promise<Cliente> =>
	await request.put(`${PATH}/${data.id}`, data)

export const get = async (id: string): Promise<Cliente> =>
	await request.get(`${PATH}/${id}`)

export const find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cliente>> =>
	await request.get(`${PATH}`, {
		params,
		...config,
	})

export const findClienteComCashback = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Cliente>> =>
	await request.get(`${PATH}/cashback`, {
		params,
		...config,
	})

export const importaItens = async(items: ClienteDaImportacaoCSV[]): Promise<any> =>
{
	await request.post(`${PATH}/importa-cliente`, items)
}

export const validarClubeDoCliente = async (cpfOuCnpjCliente: string): Promise<Cliente> =>
	await request.post(`${PATH}/valida-clube?cpfOuCnpjCliente=${cpfOuCnpjCliente}`)